// extracted by mini-css-extract-plugin
export default {"h1":"VendorCalc_h1__Y+45N","borderTop":"VendorCalc_borderTop__rSzNU","depthMove":"VendorCalc_depthMove__8lTdy"};